import AOS from 'aos';
import loadSlider from './slider';


function scrollHeader() {
    const header = document.querySelector('.header__nav');
 
    document.addEventListener('scroll', () => {
       window.pageYOffset > 50
          ? header.classList.add('header__nav--scrolled')
          : header.classList.remove('header__nav--scrolled');
    })
}

function toggleMenu() {
    if ($(window).width() < 1024) {
        const menu = $('.menu');
        const hamburger = $('.hamburger')
        menu.append($('.header__top'));

        function hideMenu() {
            hamburger.removeClass('is-open');
            menu.removeClass('is-open');
            $('body').removeClass('is-open');
            $('.overlay').fadeOut(500);
        }

        hamburger.on('click', function() {
            hamburger.toggleClass('is-open');
            menu.toggleClass('is-open');
            $('body').toggleClass('is-open');
            $('.overlay').fadeToggle(500);
        })

        $('.overlay, .menu a').on('click', function() {
            hideMenu();
        })
    }
}

function scrollToAnchor() {
    const navbarHeight = $('.header__nav').outerHeight() - 3;

    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault(); 
        const scrollTop = $($(this).attr('href')).position().top - navbarHeight;    
        $('html, body').animate({ scrollTop });
    })
}

function setActiveLinkOnScroll() {
    const scrollDistance = $(window).scrollTop();
    const navbarHeight = $('.header__nav').outerHeight();

    $('.section-link').each(function(i) {
        let activeLink = $('.section-link')[i].id;
        
        if ($(this).position().top - navbarHeight  <= scrollDistance) {
            $('#menu-main li.menu-item--active').removeClass('menu-item--active');
            $('#menu-main a[href="#'+ activeLink +'"]').parent().addClass('menu-item--active');
        }
    });
}

function keyupForm() {
    const inputs = document.querySelectorAll('.form input, .form textarea');
 
    if (inputs.length > 0) {
       
        inputs.forEach(input => {
            if (input.type != 'checkbox') {
                const wrap = input.closest('.form__group');
                let label;
                    
                input.addEventListener('focus', () => {
                    label = wrap.querySelector('label');
                    label.classList.add('focus');
                })
                input.addEventListener('blur', () => {        
                    if (input.value == '') {
                    label = wrap.querySelector('label');
                    label.classList.remove('focus');
                    }
                })
            }
        })
    
        $('.form input, .form textarea').on('keyup', function() {
            $(this).siblings('.wpcf7-not-valid-tip').addClass('hide');
        });

        $('.select-items div').on('click', function() {
            $(this).closest('.custom-select').find('.wpcf7-not-valid-tip').addClass('hide');
        });
    }
}

function toggleText() {
    $('.form__accept-button').on('click', function() {
        $('.form__accept-desc').slideToggle(200);
    });
}

function orphans() {
    $('.orphan-chars').each(function(){
        $(this).html($(this).html().replace(/\s([A-Za-z])\s([A-Za-z])\s/g, ' $1&nbsp;$2&nbsp;'));
        $(this).html($(this).html().replace(/\s([A-Za-z])\s/g, ' $1&nbsp;'));
        $(this).html($(this).html().replace(/\(([A-Za-z])\s/g, '($1&nbsp;'));
        $(this).html($(this).html().replace(/\)([A-Za-z])\s/g, ')$1&nbsp;'));
        $(this).html($(this).html().replace(/([0-9])\s([0-9])/g, '$1&nbsp;$2'));
        $(this).html($(this).html().replace(/\sr.\s/g, '&nbsp;r. '));
        $(this).html($(this).html().replace(/\szł/g, '&nbsp;zł'));
        $(this).html($(this).html().replace(/\sPLN/g, '&nbsp;PLN'));
    });
}

function dropdown() {
    function hide() {
        $('.departments-modal').slideUp(200);
        $('.departments-modal__dropdown').removeClass('departments-modal__dropdown--active');
    }

    $('.departments-modal__dropdown').on('click', function() {
        $('.departments-modal').slideToggle(200);
        $('.departments-modal__dropdown').toggleClass('departments-modal__dropdown--active');
    });

    $('.departments-modal__close-btn').on('click', function() {
        hide();
    });

    $('html').on('click', function(e) {
        const modal = $(".departments-modal, .departments-modal__dropdown");
        if (!modal.is(e.target) && modal.has(e.target).length === 0 && $(e.target).closest(".departments-modal").length === 0) {
            hide();
        }
    });
}

function options() {
    if ($(window).width() < 1279) {
        function hide() {
            $('.sidebar__box-content').removeClass('sidebar__box-content--active');
            $('.sidebar__box-title').removeClass('sidebar__box-title--active');
        }
        $('.sidebar__box-title').each(function() {
            $(this).on('click', () => {
                if ($(this).hasClass('sidebar__box-title--active')) {
                    $(this).removeClass('sidebar__box-title--active');
                    $(this).closest('.sidebar__box').find('.sidebar__box-content').removeClass('sidebar__box-content--active');
                }
                else {
                    hide();
                    $(this).addClass('sidebar__box-title--active');
                    $(this).closest('.sidebar__box').find('.sidebar__box-content').addClass('sidebar__box-content--active');
                }
            });
        })
        

        $('html').on('click', function(e) {
            const modal = $(".sidebar__box-content, .sidebar__box-title");
            if (!modal.is(e.target) && modal.has(e.target).length === 0 && $(e.target).closest(".sidebar__box-content").length === 0) {
                hide();
            }
        });
    }
}

function sctollToTop() {
    if ($(window).width() > 1279) {
        const btn = $('.scroll-to-top');

        document.addEventListener('scroll', () => {
            if ($(window).scrollTop() > 850) btn.fadeIn();
            else btn.fadeOut();
        })
        
        btn.on('click', () => {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        });
    }
}

function selectCheckboxes() {
    $('.form__checkbox--all').on('click', function() {
        $('input:checkbox').not(this).prop('checked', this.checked);
    });
    const checkboxCount = $('.form__checkbox--inside').length;
    $('.form__checkbox--inside').on('click', function() {
        $('.form__checkbox--inside').each(function () { 
            if (!$(this).is(':checked')) {
                $('.form__checkbox--all').prop('checked', false);
            }
        });
    });
}

function cookies() {
    let agree = localStorage.getItem('cookie_agree');
    let container = document.querySelector('.cookieInfo');
    if( agree ) {
        if(container) {
            container.style.display = 'none';
        }
    } else {
        container.style.display = 'block';
        let btn = document.querySelector('#close-cookies');
        console.log(btn);

        if(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                localStorage.setItem('cookie_agree', true);

                if(container) {
                    container.style.display = 'none';
                }
            });
        }
    }
}

function shareSocial() {
    const shareButtons = document.querySelectorAll(".share-btn");

  if (shareButtons) {
      [].forEach.call(shareButtons, function(button) {
      button.addEventListener("click", function(event) {
        const width = 650;
        const height = 450;
        event.preventDefault();
        
        window.open(
            this.href, 
            'Share Dialog', 
            `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${(screen.height/2-height/2)},left=${(screen.width/2-width/2)}`
        );
      });
    });
  }
}

window.addEventListener('resize', () => {
    scrollHeader();
});
window.addEventListener('scroll', setActiveLinkOnScroll);

document.addEventListener('DOMContentLoaded', () => {
    AOS.init({ 
        once: true,
        disable: 'mobile',
    });
    scrollHeader();
    toggleMenu();
    scrollToAnchor();
    setActiveLinkOnScroll();
    dropdown();
    options();
    loadSlider();
    keyupForm();
    toggleText();
    sctollToTop();
    selectCheckboxes();
    cookies();
    shareSocial();
    orphans();
})



//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 4
// module chunks = 0